import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { take } from 'rxjs';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-refuel-sum-view, [app-refuel-sum-view]',
  templateUrl: './refuel-sum-view.component.html',
  styleUrls: ['./refuel-sum-view.component.scss'],
})
export class RefuelSumViewComponent implements OnChanges {
  @Input() orderId: string | undefined;
  public sum: number | null | undefined;

  constructor(private apollo: Apollo) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.orderId) {
      this.apollo.query<fromGraphQl.CalculateRefueledTotalSumQueryResponse>({
        fetchPolicy: 'network-only',
        query: fromGraphQl.CALCULATE_REFUELED_TOTAL_SUM_QUERY,
        variables: { orderId: this.orderId }
      }).pipe(take(1)).subscribe((data) => {
        this.sum = data?.data?.calculateRefueledTotalSum;
      });
    }
  }
}
